import CommonDatePicker from "@/common/elements/DatePicker";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import Modal from "@/common/elements/Modal";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import {
  getOptionsFromRefList,
  isNonEmptyVariable,
} from "@/util/common_function";
import { Button, Form } from "antd";
import { useEffect } from "react";

const SkillsCertificationsModal = ({
  show,
  handleCancel,
  formSubmit,
  selectSkill,
  bookingsFieldsEnabled = true
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (isNonEmptyVariable(selectSkill)) {
      form.setFieldsValue(selectSkill);
    } else {
      form.resetFields();
    }
  }, [selectSkill]);

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      const data = {
        ...values,
        scheduledDate: isNonEmptyVariable(values?.scheduledDate)
          ? values?.scheduledDate?.format("MM/DD/YYYY")
          : null,
        completedDate: isNonEmptyVariable(values?.completedDate)
          ? values?.completedDate?.format("MM/DD/YYYY")
          : null,
        certificationDate: isNonEmptyVariable(values?.certificationDate)
          ? values?.certificationDate?.format("MM/DD/YYYY")
          : null,
      };
      formSubmit(data);
      form.resetFields();
    });
  };
  function handleFormCancel() {
    handleCancel()
    form.resetFields();
  }
  return (
    <>
      <Modal
        show={show}
        header={`${selectSkill ? "VIEW" : "ADD"} Skills & Certificates`}
        onHide={handleFormCancel}
        handleCancel={handleFormCancel}
        handleSubmit={handleSubmit}
        designPattern="ant"
        width="75%"
        footerActions={[
          <Button key="SUBMIT" onClick={handleFormCancel} disabled={!bookingsFieldsEnabled}>
            Close
          </Button>,
          <Button key="SUBMIT" onClick={handleSubmit} disabled={!bookingsFieldsEnabled}>
            Submit
          </Button>
        ]
        }
      // submitButtonDisabled={!bookingsFieldsEnabled}
      >
        <Form form={form} disabled={!bookingsFieldsEnabled}>
          <StyledGridRow gutter={[16]}>
            <StyledGridCol lg={18}>
              <FormItem name="skillName" label="Skill Name">
                <Select
                  id="skillName"
                  options={getOptionsFromRefList("Staff_Skill_Name")}
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol lg={6}>
              <FormItem label="Skill Level" name="skillLevel">
                <Select
                  id="skillLevel"
                  options={getOptionsFromRefList("Staff_Skill_Level")}
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
          <StyledGridRow gutter={[16]}>
            <StyledGridCol lg={24}>
              <FormItem name="skillDesc" label="Skill Description">
                <TextField id="skillDescription" inputType="textarea" />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
          <StyledGridRow gutter={[16]}>
            <StyledGridCol lg={9}>
              <FormItem label="Training" name="trainingName">
                <TextField id="training" />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol lg={6}>
              <FormItem label="Scheduled Date" name="scheduledDate">
                <CommonDatePicker
                  id="scheduledDate"
                  format="MM/DD/YYYY"
                  showTime={false}
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol lg={6}>
              <FormItem label="Completed Date" name="completedDate">
                <CommonDatePicker
                  id="completedDate"
                  format="MM/DD/YYYY"
                  showTime={false}
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol lg={3}>
              <FormItem label="Hours" name="trainingHours">
                <TextField id="hours" type="number" />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
          <StyledGridRow gutter={[16]}>
            <StyledGridCol lg={24}>
              <FormItem label="Training Description" name="trainingDesc">
                <TextField id="trainingDescription" inputType="textarea" />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
          <StyledGridRow gutter={[16]}>
            <StyledGridCol lg={14}>
              <FormItem label="Certificate" name="certificationName">
                <TextField id="certificate" />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol lg={6}>
              <FormItem label="Date Received" name="certificationDate">
                <CommonDatePicker
                  id="dateReceived"
                  format="MM/DD/YYYY"
                  showTime={false}
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol lg={4}>
              <FormItem label="Hours" name="certificationHours">
                <TextField id="certificateHours" type="number" />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
          <StyledGridRow gutter={[16]}>
            <StyledGridCol lg={24}>
              <FormItem
                label="Certificate Description"
                name="certificationDesc"
              >
                <TextField id="certificateDescription" inputType="textarea" />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
        </Form>
      </Modal>
    </>
  );
};

export default SkillsCertificationsModal;
